<div class="preview-container w-100">
  <div class="preview-underlay">
    <div class="preview-underlay-watermark orange w-100">Preview Mode</div>
    <div class="preview-underlay-watermark purple w-100">Preview Mode</div>
    <div class="preview-underlay-watermark green w-100">Preview Mode</div>
  </div>
</div>
